import { render, staticRenderFns } from "./ListItemEmptyPlaceholder.vue?vue&type=template&id=0af7f800&scoped=true&functional=true&"
import script from "./ListItemEmptyPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ListItemEmptyPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ListItemEmptyPlaceholder.vue?vue&type=style&index=0&id=0af7f800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0af7f800",
  null
  
)

export default component.exports